module.exports = __webpack_public_path__ + "img/why-championla_image2.fc6cefa7.jpg";